// Exportación genérica a Excel (.xlsx).
//
// Los valores numéricos se escriben como números, no como strings formateados,
// para que Excel pueda sumarlos. El formato de miles/decimales lo aplica el
// usuario en la planilla; acá solo importa el dato.

import * as XLSX from 'xlsx';

// Excel rechaza : \ / ? * [ ] en nombres de hoja y limita a 31 caracteres.
const sanitizeSheetName = (name) =>
  String(name || 'Datos').replace(/[:\\/?*[\]]/g, '-').slice(0, 31);

const sanitizeFileName = (name) =>
  String(name || 'export').replace(/[<>:"\\/|?*]/g, '-').replace(/\s+/g, ' ').trim();

/**
 * Descarga un array de objetos planos como .xlsx. Las claves del primer objeto
 * definen los encabezados, así que todas las filas deben tener la misma forma.
 *
 * @param {Array<object>} rows
 * @param {{ fileName: string, sheetName?: string, columnWidths?: number[] }} options
 * @returns {boolean} false si no había filas para exportar
 */
export const exportRowsToXlsx = (rows, { fileName, sheetName = 'Datos', columnWidths } = {}) => {
  if (!Array.isArray(rows) || rows.length === 0) return false;

  const sheet = XLSX.utils.json_to_sheet(rows);
  if (columnWidths) {
    sheet['!cols'] = columnWidths.map(wch => ({ wch }));
  }
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, sanitizeSheetName(sheetName));
  XLSX.writeFile(book, `${sanitizeFileName(fileName)}.xlsx`);
  return true;
};
